import i18next from 'i18next';
import Backend from 'i18next-xhr-backend';

import isFashionUnitedSite from '../lib/isFashionUnitedSite';

export default i18next
  .use(Backend)
  .init({
    fallbackLng: 'en',
    debug: false,
    backend: {
      loadPath: isFashionUnitedSite() ||
        /^https?:\/\/localhost:/.test(window.location.href) ?
        '/global-assets/embed/assets/i18n/{{lng}}.i18n.json' :
        'https://fashionunited.com/global-assets/embed/assets/i18n/{{lng}}.i18n.json',
    },
  });
